import StudioPlansHandler from './StudioPlansHandler';

export default StudioPlansHandler;
